"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMTGFuturesAI = void 0;
const react_1 = require("react");
const TradeAPILib_1 = require("TradeAPILib");
const BotAPI_1 = require("../../../BotAPI");
const useMTGFuturesAI = (base, quote, trend) => {
    const [info, setInfo] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        setInfo(undefined);
        setError(undefined);
        setLoading(true);
        const sub = (0, BotAPI_1.botFuturesAI)({ base, quote, trend }, TradeAPILib_1.ExchangeOrderType.futures_martingale).subscribe({
            next: (res) => {
                if (res) {
                    setInfo(res);
                }
                setLoading(false);
            },
            error: (err) => {
                setError(err);
                setLoading(false);
            },
        });
        return () => sub.unsubscribe();
    }, [base, quote, trend]);
    return { info: info, error: error, loading: loading };
};
exports.useMTGFuturesAI = useMTGFuturesAI;
